<markant-dialog
  class="dialog"
  [headTitle]="'audit.changeReason.title' | transloco"
  [open]="true"
  (close)="closeDialog()"
>
  <div class="info">
    {{ 'audit.changeReason.label' | transloco }}
  </div>

  <form class="content content-form">
    <markant-textarea
      [formControl]="reason"
      cols="60"
      [placeholder]="'audit.changeReason.validation.required' | transloco"
      [outlined]="true"
      [error]="reason.errors | formControlError: reason.touched || reason.dirty"
      [helperValidation]="true"
      [helper]="
        reason.errors
          | formControlKeyError
            : 'audit.changeReason.validation'
            : reason.touched || reason.dirty
          | transloco
      "
      [showLabelHint]="true"
      [required]="true"
      [showCharacterCounter]="true"
    >
    </markant-textarea>
  </form>
  <div class="button" slot="footer">
    <markant-button
      (click)="closeDialog()"
      colorScheme="primary"
      variant="clear"
    >
      {{ 'common.cancel' | transloco }}
    </markant-button>
    <markant-button (click)="save()" colorScheme="primary">
      {{ 'common.save' | transloco }}
    </markant-button>
  </div>
</markant-dialog>
